<!--
 * @Description: 按钮分组显示
 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="btn-list-com" v-if="showBtnList">
    <draggable animation="500" :disabled="!props?.sort" :group="{ name: 'btnGroup', sort: true, pull: true }" @end="onEnd" :list="data.btnModules" class="btn-list-draggable-content">
      <template #item="{ element, index }">
        <div v-if="element?.showField" :class="['btn-list-com-content', !props?.sort ? 'disabled-drag-sort' : 'enabled-drag-sort']" :key="index">
          <div class="list-left">
            <qfei-icon-more-two-outlined :class="['mover', 'hand', 'icon-drag-mover', !props?.sort ? 'disabled-drag-icon' : '']" size="14" />
            <span class="btn-name">{{ element.label }}</span>
          </div>
          <div class="list-right">
            <jw-tooltip :content="$t('删除')">
              <jw-button type="text" size="small" class="delete-icon-btn delete-icon" @click="del(index)">
                <qfei-icon-delete-outlined />
              </jw-button>
            </jw-tooltip>
          </div>
        </div>
      </template>
    </draggable>
  </div>
</template>
<script setup>
import { reactive, watchEffect, computed } from 'vue';
import { QfeiIconDeleteOutlined, QfeiIconMoreTwoOutlined } from '@qfei-design/icons-vue';
import draggable from 'vuedraggable';
const emits = defineEmits(['cb']);
const props = defineProps({
  list: {
    // 全部数据
    type: Object,
    default: () => {}
  },
  sort: {
    //是否支持排序
    type: Boolean,
    default: true
  }
});
const data = reactive({
  AlllListData: {}, //所有数据
  btnModules: [] //按钮信息
});

watchEffect(() => {
  data.AlllListData = props.list;
  data.btnModules = props?.list?.modules;
});
// 计算是否显示按钮列表
const showBtnList = computed(() => {
  return data.btnModules?.length > 0 && data.btnModules?.filter((v) => v?.showField).length > 0;
});
const exposeAlllListData = () => {
  //抛出数据
  emits('cb', { ...data.AlllListData, modules: data.btnModules });
};

// 删除
const del = (index) => {
  data.btnModules[index].showField = false;
  exposeAlllListData();
};
const onEnd = () => {
  exposeAlllListData();
};
</script>

<style scoped lang="less">
@import './btn-list.less';
</style>
